import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../../components/footer/index';

const features = [
  { title: 'Real-time Monitoring', desc: 'Pantau seluruh perangkat jaringan secara real-time dengan dashboard interaktif.', icon: '📡' },
  { title: 'Alert & Notifikasi', desc: 'Sistem peringatan otomatis via email, SMS, dan Telegram saat terjadi gangguan.', icon: '🔔' },
  { title: 'Performance Analytics', desc: 'Analisis performa bandwidth, latency, dan packet loss secara historis.', icon: '📊' },
  { title: 'Topology Mapping', desc: 'Visualisasi topologi jaringan otomatis untuk identifikasi masalah cepat.', icon: '🗺️' },
  { title: 'SLA Reporting', desc: 'Laporan SLA otomatis untuk memenuhi komitmen uptime kepada pelanggan.', icon: '📄' },
  { title: 'Predictive Maintenance', desc: 'AI-powered prediction untuk mencegah downtime sebelum terjadi.', icon: '🤖' },
];

const NetworkMonitoringPage = () => {
  React.useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <section className="relative bg-gradient-to-br from-orange-900 via-amber-800 to-yellow-900 text-white py-24 px-4">
        <div className="max-w-6xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">Network Monitoring</h1>
          <p className="text-lg md:text-xl text-orange-200 max-w-3xl mx-auto">
            Solusi monitoring jaringan enterprise untuk visibilitas penuh dan uptime maksimal infrastruktur IT Anda.
          </p>
        </div>
      </section>

      <section className="py-20 px-4">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold text-center mb-12 text-gray-800 dark:text-white">Fitur Monitoring</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {features.map((f) => (
              <div key={f.title} className="bg-white dark:bg-gray-800 rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all hover:-translate-y-1">
                <div className="text-4xl mb-4">{f.icon}</div>
                <h3 className="text-xl font-bold mb-3 text-gray-800 dark:text-white">{f.title}</h3>
                <p className="text-gray-600 dark:text-gray-300">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-amber-900 text-white py-16 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold mb-4">Jangan Tunggu Downtime Terjadi</h2>
          <p className="text-amber-200 mb-8">Setup monitoring proaktif untuk jaringan Anda sekarang.</p>
          <Link to="/kontak" className="inline-block bg-white text-amber-900 font-bold px-8 py-4 rounded-xl hover:bg-amber-50 transition-colors">
            Mulai Sekarang
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default NetworkMonitoringPage;
